import { render, staticRenderFns } from "./readNewspapersDetail.vue?vue&type=template&id=375a5127&scoped=true&"
import script from "./readNewspapersDetail.vue?vue&type=script&lang=js&"
export * from "./readNewspapersDetail.vue?vue&type=script&lang=js&"
import style0 from "./readNewspapersDetail.vue?vue&type=style&index=0&id=375a5127&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "375a5127",
  null
  
)

export default component.exports